import { functionsAxiosInstance } from "../api"
import type { GetTypesenseApiKeyResponse } from "./types"

export async function getTypesenseApiKey(): Promise<GetTypesenseApiKeyResponse> {
  const result = await functionsAxiosInstance.get<GetTypesenseApiKeyResponse>(
    "v1/getTypesenseApiKey",
  )
  return result.data
}
